import React, { useState, useEffect, FC } from "react";
import {
  ChevronLeft,
  ChevronRight
} from "lucide-react";
import { ANSWERSTATUSENUM } from "../../environment";
import ExamQuestionPanel from "./ExamQuestionPanel";
type ExamQuestionPanelForMobileTypes = {
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  timeLeft: {
    hours: string;
    minutes: string;
    seconds: string;
  };
  secondsAnimated: boolean;
  getStattusCount: (type: ANSWERSTATUSENUM) => any;
  getNotVisitCount: () => any;
  examQuestionDetails: any;
  handleChangeDisplay: (questionIndex?: number) => void;
  currentIndex: number;
};

const ExamQuestionPanelForMobile: FC<ExamQuestionPanelForMobileTypes> = ({
  collapsed,
  setCollapsed,
  timeLeft,
  currentIndex,
  handleChangeDisplay,
  examQuestionDetails,
  getNotVisitCount,
  getStattusCount,
  secondsAnimated
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth < 768) {
        setCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleExamQuestionPanelForMobile = () => {
    setCollapsed(!collapsed);
  };

  return (
    <aside
      className={`bg-neutral-50 border-r border-gray-200 fixed h-[90.2vh]  z-20 shadow-sm transition-all duration-300 ease-in-out flex flex-col ${
        collapsed ? "w-[90vw]" : "w-56"
      } ${isMobile && collapsed ? "-translate-x-full" : "translate-x-0"}`}
    >
    
      <div>
        <ExamQuestionPanel
          timeLeft={timeLeft}
          secondsAnimated={secondsAnimated}
          getStattusCount={getStattusCount}
          getNotVisitCount={getNotVisitCount}
          examQuestionDetails={examQuestionDetails}
          handleChangeDisplay={handleChangeDisplay}
          currentIndex={currentIndex}
          setCollapsed={setCollapsed}
          forMobile
        />
      </div>
    </aside>
  );
};

export default ExamQuestionPanelForMobile;
